import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { m: "4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaterialTable = _resolveComponent("MaterialTable")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.businessList,
    style: {"width":"100"},
    border: "",
    stripe: "",
    "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
    "summary-method": _ctx.getSummaries,
    "show-summary": "",
    onSelectionChange: _ctx.handleTableSelect
  }, {
    default: _withCtx(() => [
      (_ctx.isShowExpand)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            type: "expand",
            width: "60"
          }, {
            default: _withCtx((props) => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_MaterialTable, {
                  materialData: props.row.children
                }, null, 8, ["materialData"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "before"),
      (_ctx.isRateVisible)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_table_column, {
              prop: "orderFee",
              label: "业务税率",
              "min-width": "90"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.orderTaxRate) + "%", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "orderFee",
              label: "单价(含税)",
              "min-width": "100",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$currency(row.orderFee)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "priceWithRate",
              label: "单价(未税)",
              "min-width": "100",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.priceWithoutRate(row.orderFee, row.amount, true, row.orderTaxRate)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "totalPrice",
              label: "总价(含税)",
              "min-width": "100",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.orderFee, row.amount, true)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "totalPriceWithRate",
              label: "总价(未税)",
              "min-width": "100",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.totalPriceWithoutRate(row.orderFee, row.amount, true, row.orderTaxRate)), 1)
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "after")
    ]),
    _: 3
  }, 8, ["data", "summary-method", "onSelectionChange"]))
}